import { PanelType } from '../../../../panels/types';

interface StagePanelDataType {}

export const stagePanelType: PanelType<StagePanelDataType> = {
  name: 'STAGE_DIALOG',
  location: 'right',
};
